import { c as _c } from "react/compiler-runtime";
import { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateNumericValue from "./common/GroupCreateNumericValue";
export default function GroupCreateTDH(t0) {
  const $ = _c(7);
  const {
    tdh,
    setTDH
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-4"><p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">TDH</p><p className="tw-mt-1 tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-300">Set the group's minimum TDH requirement.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setTDH || $[2] !== tdh) {
    t2 = value => setTDH({
      ...tdh,
      min: value
    });
    $[1] = setTDH;
    $[2] = tdh;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== tdh.min) {
    t3 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800">{t1}<GroupCreateNumericValue value={tdh.min} label="TDH at least" labelId="floating_tdh" setValue={t2} /></div>;
    $[4] = t2;
    $[5] = tdh.min;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}